import { differenceInCalendarDays } from 'date-fns';

import { oneWayTripDefaultNights } from '~constants/defaultValues';
import type { CheckoutSegment } from '~touchpoints/HotelDealsMobileCard/types';

interface GetAmountOfNightsParams {
  segments: CheckoutSegment[];
  isOneWay: boolean;
  isMeta: boolean;
  amountNightsProp: number;
}

const calculateTravelDays: ({
  startSegment,
  endSegment,
}: {
  startSegment: CheckoutSegment;
  endSegment: CheckoutSegment;
}) => number = ({ startSegment, endSegment }) => {
  const startDate = new Date(startSegment.sections[0].departureDate);
  const endDate = new Date(endSegment.sections[0].arrivalDate);

  return differenceInCalendarDays(endDate, startDate);
};

const getAmountOfNights = ({
  segments,
  isOneWay,
  isMeta,
  amountNightsProp,
}: GetAmountOfNightsParams) => {
  if (isOneWay) {
    return oneWayTripDefaultNights;
  }
  if (isMeta) {
    return calculateTravelDays({
      startSegment: segments[0],
      endSegment: segments[1],
    });
  } else {
    return amountNightsProp;
  }
};

export default getAmountOfNights;
